// extracted by mini-css-extract-plugin
export default {"container":"Cloud_container__wtxg3","cloud":"Cloud_cloud__rruk4","cvBtnIn":"Cloud_cvBtnIn__3yzvr","name":"Cloud_name__xFeeH"};